<template>
  <div>
    <div class="chart-box-top">
      <span v-if="chartTitle" class="chart-title">{{ chartTitle }}</span>
      <span v-else class="chart-title">征候类横向对比（年度累积至{{ accMonth }}月）</span>
      <div class="chart-select-container">
        <div class="el-select-wrapper">
          <el-select v-model="symptom" placeholder="请选择">
            <el-option v-for="item in symptomOptions" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div class="el-select-wrapper">
          <el-select v-model="classify" placeholder="请选择">
            <el-option value="group" label="集团内"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div ref="chart" class="chart-main">
    </div>
    <el-dialog title="明细列表" :visible.sync="detailVisible" width="95%">
      <SymptomDetail ref="detail" :symptom="symptom" :company="barCompany"
                     :year="year"></SymptomDetail>
    </el-dialog>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";
import SymptomDetail from "./SymptomDetail";
import {showMessage} from "../../../utils/notice";

export default {
  props: {
    year: Number,
    company: String,
    //可选择的征候
    symptomOptions: Array,
    //初始值
    initSymptom: String,
    //图表标题
    chartTitle: String,
  },
  data() {
    return {
      symptom: "SR-003",
      //集团内/外
      classify: "group",
      xAxisData: [],
      symptomCounts: [],
      tenThousandHourRates: [],
      //右Y轴单位
      actualValueMeasuringUnit: "万时率",
      groupTargets: [],
      //是否显示明细列表
      detailVisible: false,
      //用户点击的公司
      barCompany: null,
      accMonth: null,
      chart: null
    }
  },
  computed: {
    /**
     * 事件数量series名称，严差时显示”严差数量“，征候时显示”征候数量“，默认显示”征候数量“
     */
    symptomCountName() {
      if ("SR-047" === this.symptom) {
        return "二类事件数量";
      } else if ("SR-009" === this.symptom) {
        return "一类事件数量";
      } else {
        return "征候数量"
      }
    },
    /**
     * 是否为严差红线指标
     */
    isSeriousRedLineKpi() {
      return "SR-009" === this.symptom;
    },
  },
  mounted() {
    if (this.initSymptom)
      this.symptom = this.initSymptom;

    let querySymptom = this.$route.query.symptom;
    if (this.symptomOptions.some(option => option.code === querySymptom))
      this.symptom = querySymptom;

    this.buildChart();
    window.addEventListener('resize', () => {
      this.chart && this.chart.resize()
    })
  },
  methods: {
    /**
     * 征候类横向对比
     */
    buildChart() {
      let kpi = this.symptomOptions.find(option => option.code === this.symptom);
      this.actualValueMeasuringUnit = kpi.measuringUnitName;

      getRequest("/result/symptom/chart/horizontal", {
        symptom: this.symptom,
        year: this.year,
        company: this.company
      }, this.$refs.chart).then(res => {
        this.xAxisData = [];
        this.symptomCounts = [];
        this.tenThousandHourRates = [];
        this.groupTargets = [];

        this.accMonth = res.data.accMonth;

        res.data.reports.forEach(item => {
          //特殊处理，实际值默认为0，以保证线条可以连贯
          if (item.tenThousandHourRate === null) item.tenThousandHourRate = 0;

          this.xAxisData.push(item.company.shortName);

          let eventCount = this.isSeriousRedLineKpi ? item.weightedEventCount : item.eventCount;
          this.symptomCounts.push({value: eventCount, full: item});
          //this.tenThousandHourRates.push({value: item.tenThousandHourRate, full: item});
          this.groupTargets.push({value: item.groupTarget, full: item});

          if (kpi.measuringUnit === "1000timesRte") {
            this.tenThousandHourRates.push({value: item.thousandCountRate, full: item});
          } else if (kpi.measuringUnit === "10000hourRate") {
            this.tenThousandHourRates.push({value: item.tenThousandHourRate, full: item});
          } else if (kpi.measuringUnit === "10000timesRate") {
            this.tenThousandHourRates.push({value: item.tenThousandCountRate, full: item});
          } else {
            let errorMessage = "该指标选择的单位不支持，请在KPI总库中修改";
            showMessage(errorMessage, "error")
            throw new Error(errorMessage)
          }
        })
        this.chart = this.$echarts.init(this.$refs.chart);
        this.chart.setOption(this.getOption());
        this.chart.on("click", "series.bar", params => {
          this.barCompany = params.data.full.company.code;
          this.detailVisible = true;
          this.$refs.detail && this.$refs.detail.initPage();
        })

        this.$util.adjustYaxis(this.chart, this.$util.getMax(this.tenThousandHourRates, this.groupTargets));
      })
    },

    getOption() {
      return {
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 0
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          padding: [5, 10],
          confine: true
        },
        legend: {
          itemWidth: 12,
          itemHeight: 12,
        },
        xAxis: {
          data: this.xAxisData,
          axisLabel: {
            fontSize: 11,
            color: "#bebebe",
            interval: 0
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [
          {
            name: "起",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"起"字与左y轴对齐
              align: "right",
              padding: [0, 5, 0, 0]
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe"
            }
          }, {
            name: this.actualValueMeasuringUnit,
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"万时率"与右y轴对齐
              align: "center",
              padding: [0, 0, 0, 20]
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe"
            }
          }],
        series: [
          {
            name: this.symptomCountName,
            type: 'bar',
            data: this.symptomCounts,
            yAxisIndex: 0,
            barWidth: 10,
            itemStyle: {
              color: "#257dff"
            },
          }, {
            name: this.actualValueMeasuringUnit,
            type: 'line',
            data: this.tenThousandHourRates,
            yAxisIndex: 1,
            //默认是空心圆，改为实心圆，大小为6
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: "#F3A800",
              borderType: "solid"
            },
            lineStyle: {
              color: "#F3A800",
            },
          }, {
            name: '集团目标',
            type: 'line',
            data: this.groupTargets,
            yAxisIndex: 1,
            symbol: "none",
            symbolSize: 6,
            itemStyle: {
              color: "#3BD393",
              borderType: "solid"
            },
            lineStyle: {
              color: "#3BD393",
              width: 1
            },
          }]
      };
    },
  },
  watch: {
    year() {
      this.buildChart();
    },
    symptom() {
      this.buildChart();
    },
    company() {
      this.buildChart();
    }
  },
  components: {
    SymptomDetail
  }
}
</script>

<style scoped lang="less">
.el-select-wrapper:nth-child(1) {
  width: 117px;
}

.el-select-wrapper:nth-child(2) {
  width: 78px;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/result/SymptomHorizontal.vue